var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "#BCC3D0",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_43_628)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 5.01246C15.5 4.11226 14.4234 3.66144 13.7938 4.29798L10.6984 7.4273C8.56612 9.58289 7.5 10.6607 7.5 12C7.5 13.3393 8.56612 14.4171 10.6984 16.5727L13.7938 19.702C14.4234 20.3386 15.5 19.8877 15.5 18.9875C15.5 18.7196 15.3947 18.4625 15.2073 18.2731L12.1118 15.1437C11.0058 14.0255 10.3214 13.3276 9.88882 12.7544C9.49838 12.2371 9.49883 12.0565 9.49897 12.0028L9.49897 12L9.49897 11.9973C9.49883 11.9435 9.49838 11.7629 9.88882 11.2456C10.3214 10.6724 11.0058 9.97446 12.1118 8.85627L15.2073 5.72695C15.3947 5.53745 15.5 5.28044 15.5 5.01246Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_43_628"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.e535622ab05b4828c47dd288c0a5863b.svg";
export { ForwardRef as ReactComponent };